import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/api";

function VehicleCard({ vehicle }) {
  const [isMobile, setIsMobile] = useState(false);

  const getAverageRating = (ratings) => {
    if (!ratings || ratings.length === 0) return "N/A"; // Handle empty arrays
    const sum = ratings.reduce((acc, rating) => acc + rating, 0);
    return (sum / ratings.length).toFixed(1); // Round to 1 decimal place
  };

  // Feature 3: Lorries & Pick-up trucks show load capacity instead of seats
  const isLoadVehicle = vehicle.type === "Lorry" || vehicle.type === "Pickup";

  useEffect(() => {
    // Check if the screen width is below 768px (standard mobile breakpoint)
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Check on mount
    checkMobile();

    // Add resize event listener to detect screen size changes
    window.addEventListener('resize', checkMobile);

    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleNumberOfClicks = () => {

    const vehicleId = vehicle._id;

    api
      .post("/vehicles/updateNumberOfClicks", { vehicleId })
      .then((response) => {
        console.log(response)
      })
      .catch((error) => console.log(error));


  };

  return (
    <div className="max-w-sm bg-white border border-gray-200 rounded-lg shadow-sm md:hover:scale-105 transition-all duration-300 w-full">
      <a href="#">
        <img
          className="rounded-t-lg aspect-custom-4-3 object-cover w-full"
          src={vehicle.imageURLs[0]}
          alt={vehicle.name}
        />
      </a>
      <div className="flex flex-col gap-2 p-5 w-full ">
        <p className="mb-2 text-xl lg:text-2xl font-bold tracking-tight text-gray-900">
          {vehicle.name}
        </p>

        <div className="flex justify-between md:flex-col lg:flex-row ">
          <div className="flex flex-row space-x-2">
            <p className="font-medium">Type:</p>
            <p className="mb-2 font-normal text-gray-500">{vehicle.type}</p>
          </div>
          <div className="flex flex-row space-x-2">
            <p className="font-medium">City:</p>
            <p className="mb-2 font-normal text-gray-500">{vehicle.city}</p>
          </div>
        </div>
        {isLoadVehicle ? (
          <div className="flex flex-row space-x-2">
            <p className="font-medium">Capacity:</p>
            <p className="mb-2 font-normal text-gray-500">
              {vehicle.maxLoadCapacity ? `${vehicle.maxLoadCapacity} kg` : "N/A"}
              {vehicle.cargoSize ? ` (${vehicle.cargoSize})` : ""}
            </p>
          </div>
        ) : (
          <div className="flex flex-row space-x-2">
            <p className="font-medium">Available Seats:</p>
            <p className="mb-2 font-normal text-gray-500">
              {vehicle.availableSeats}
            </p>
          </div>
        )}
        {vehicle.pricePerKm > 0 && (
          <div className="flex flex-row space-x-2">
            <p className="font-medium">Est. Price/km:</p>
            <p className="mb-2 font-normal text-gray-500">
              LKR {vehicle.pricePerKm}
            </p>
          </div>
        )}
        <div className="flex flex-row justify-between space-x-2 w-full">
          <div className="flex items-center mb-2 w-full">
            <svg
              className="w-4 h-4 text-[#A9B9E3] me-1"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 22 20"
            >
              <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
            </svg>
            <p className="ms-2 text-xs font-bold text-gray-900 ">
              {getAverageRating(vehicle.customerRatings)}
            </p>
            <span className="w-1 h-1 mx-1.5 bg-gray-500 rounded-full "></span>
            <p

              className="text-xs font-medium text-gray-900 "
            >
              Customer
            </p>
          </div>
          <div className="flex items-center mb-2">
            <svg
              className="w-4 h-4 text-[#A9B9E3] me-1"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 22 20"
            >
              <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
            </svg>
            <p className="ms-2 text-xs font-bold text-gray-900 ">
              {getAverageRating(vehicle.fanRatings)}
            </p>
            <span className="w-1 h-1 mx-1.5 bg-gray-500 rounded-full "></span>
            <p

              className="text-xs font-medium text-gray-900"
            >
              Fan
            </p>
          </div>


        </div>

        <div className="flex justify-center w-full">
          <Link className=" w-full" to={`/book/${vehicle._id}`} target={isMobile ? "_self" : "_blank"}>
            <button
              className="inline-flex items-center px-3 py-2 text-sm font-medium text-white bg-[#6F48E5] rounded-lg hover:bg-[#A9B9E3] focus:outline-none transition-all duration-700 w-full justify-center"
              onClick={handleNumberOfClicks}
            >
              View More
              <svg
                className="w-3.5 h-3.5 ms-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default VehicleCard;
